import React, { useContext,useState }from "react";
import Card from "@mui/joy/Card";
import CardCover from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import CardActions from "@mui/joy/CardActions";
import Stack from "@mui/joy/Stack";
import Checkboxj from "@mui/joy/Checkbox";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import { CssVarsProvider } from "@mui/joy/styles";
import DiscountLabel from "./discounlabel";
import {Mycontext} from "../../logged_out/mycontext"
import axios from "axios";
import slugify from 'slugify'


const apiUrl = process.env.REACT_APP_API_URL;

const MyCard = ({ el }) => {
    const { setIsFavoriteVisible ,setCartItemsCount, cartItemsData, setCartItemsData }  = useContext(Mycontext);
    const [ishoover, setIshoover] = useState(false);

    const get_check_id = (id) => {
      if (window.localStorage.getItem("fav")) {
        let a = window.localStorage.getItem("fav");
        return a.includes(id);
      }
      return false;
    };
    const handlefav = (event) => {
      if (event.target.checked) {
        if (!window.localStorage.getItem("fav")) {
          window.localStorage.setItem("fav", event.target.value);
        } else {
          window.localStorage.setItem(
            "fav",
            window.localStorage.getItem("fav") + "," + event.target.value
          );
        }
        setIsFavoriteVisible(true);
        axios.post(apiUrl + "/favori", { data: { id: event.target.value } });
      } else {
        let a = window.localStorage.getItem("fav");
        if (a) {
          if (a.split(",").length > 1) {
            window.localStorage.setItem(
              "fav",
              a.split(",").filter((el) => el !== event.target.value).join(",")
            );
          } else {
            window.localStorage.removeItem("fav");
            setIsFavoriteVisible(false);
          }
        }
      }
    };


  return (
    <CssVarsProvider>
      <Card
        sx={{
          width: "100%",
          maxWidth: { xs: 300, lg: 400 },
          height: { xs: 130, sm: 150, md: 280, lg: 300 },
        }}
        onMouseEnter={() => setIshoover(true)} // Hover başladığında state true
        onMouseLeave={() => setIshoover(false)} // Hover bittiğinde state false
        onClick={() => {
          // Scroll pozisyonunu kaydet
          const scrollPosition = window.scrollY;
          localStorage.setItem("scrollPosition", scrollPosition);
          // Yönlendirme yap
          window.location.href = `/tuotteet/${slugify(el.type)}/${slugify(el.name)}-${el.id}`;
        }}
      >
        <CardCover>
          <img
            src={
              el.imgs !== null
                ? `${apiUrl}/images/${el.imgs.split(",")[0]}`
                : "../../../camera.jpg"
            }
            loading="lazy"
            alt={`${el.name} kuva`}
          />
        </CardCover>
        <CardCover
          sx={{
            background: {
              xs: "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0) 30px), linear-gradient(to bottom, rgba(0,0,0,0.8), rgba(0,0,0,0) 40px)",
              md: "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0) 120px), linear-gradient(to bottom, rgba(0,0,0,0.8), rgba(0,0,0,0) 90px)",
            },
          }}
        />
        <CardContent sx={{ justifyContent: "flex-start" }}>
          <Stack direction="row" justifyContent="space-between">
           <Typography
              level="title-sm"
              textColor="#fff"
              sx={{ fontSize: { xs: 9, sm: 12, md: 14, lg: 16 } }}
            >
              {el.name}
            </Typography>
            <Stack direction="column" alignItems="flex-end" spacing={1}>
              {(el.status === "Reserved" || el.status === "Sold") && (
                <Typography
                  variant="solid"
                  color={el.status === "Reserved" ? "primary" : "danger"}
                  sx={{
                    fontSize: { xs: 8, sm: 10, md: 14 },
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  {el.status === "Sold" ? " Myyty " : " Varattu "}
                </Typography>
              )}
              {ishoover && (
                <Checkboxj
                  variant="soft"
                  size="lg"
                  color="danger"
                  key={el.id}
                  value={el.id}
                  onChange={handlefav}
                  defaultChecked={get_check_id(el.id)}
                  uncheckedIcon={<FavoriteBorder />}
                  checkedIcon={<Favorite />}
                  onClick={(event) => {
                    event.stopPropagation(); // Tıklamanın kartın onClick olayını tetiklemesini engelliyoruz
                  }}
                />
              )}
            </Stack>
          </Stack>
        </CardContent>
        <CardActions sx={{ justifyContent: "space-between" }}>
          <DiscountLabel sale={el.sale} />
        </CardActions>
      </Card>
    </CssVarsProvider>
  );
};

export default MyCard;
